// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* @description NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var AccountRoleType;
(function (AccountRoleType) {
    AccountRoleType[AccountRoleType["Unknown"] = 0] = "Unknown";
    AccountRoleType[AccountRoleType["Patient"] = 1] = "Patient";
    AccountRoleType[AccountRoleType["Prescriber"] = 2] = "Prescriber";
    AccountRoleType[AccountRoleType["InsuranceProvider"] = 3] = "InsuranceProvider";
    AccountRoleType[AccountRoleType["PharmacyBenefitManager"] = 4] = "PharmacyBenefitManager";
    AccountRoleType[AccountRoleType["SecondaryContact"] = 5] = "SecondaryContact";
    AccountRoleType[AccountRoleType["Manufacturer"] = 6] = "Manufacturer";
    AccountRoleType[AccountRoleType["EMP"] = 7] = "EMP";
    AccountRoleType[AccountRoleType["CustomerServiceRep"] = 8] = "CustomerServiceRep";
    AccountRoleType[AccountRoleType["PrescriberSite"] = 9] = "PrescriberSite";
    AccountRoleType[AccountRoleType["Brand"] = 10] = "Brand";
    AccountRoleType[AccountRoleType["Child"] = 11] = "Child";
    AccountRoleType[AccountRoleType["SocialWorker"] = 12] = "SocialWorker";
    AccountRoleType[AccountRoleType["FinancialRepresentative"] = 13] = "FinancialRepresentative";
    AccountRoleType[AccountRoleType["LegalRepresentative"] = 14] = "LegalRepresentative";
    AccountRoleType[AccountRoleType["Corporate"] = 15] = "Corporate";
    AccountRoleType[AccountRoleType["PersonalContact"] = 16] = "PersonalContact";
    AccountRoleType[AccountRoleType["Spouse"] = 17] = "Spouse";
    AccountRoleType[AccountRoleType["Parent"] = 18] = "Parent";
    AccountRoleType[AccountRoleType["HomeHealth"] = 19] = "HomeHealth";
    AccountRoleType[AccountRoleType["AlternateContact"] = 20] = "AlternateContact";
    AccountRoleType[AccountRoleType["AutoInjuryPlan"] = 21] = "AutoInjuryPlan";
    AccountRoleType[AccountRoleType["CommercialPlan"] = 22] = "CommercialPlan";
    AccountRoleType[AccountRoleType["FederalEmployeeProgram"] = 23] = "FederalEmployeeProgram";
    AccountRoleType[AccountRoleType["Medicaid"] = 24] = "Medicaid";
    AccountRoleType[AccountRoleType["MedicareAdvantage"] = 25] = "MedicareAdvantage";
    AccountRoleType[AccountRoleType["MedicareB"] = 26] = "MedicareB";
    AccountRoleType[AccountRoleType["MedicareD"] = 27] = "MedicareD";
    AccountRoleType[AccountRoleType["MediGap"] = 28] = "MediGap";
    AccountRoleType[AccountRoleType["VADoDTRICARE"] = 29] = "VADoDTRICARE";
    AccountRoleType[AccountRoleType["WorkersCompensation"] = 30] = "WorkersCompensation";
    AccountRoleType[AccountRoleType["Plan"] = 31] = "Plan";
    AccountRoleType[AccountRoleType["Payer"] = 32] = "Payer";
    AccountRoleType[AccountRoleType["DurableMedicalEquiqmentPlan"] = 33] = "DurableMedicalEquiqmentPlan";
    AccountRoleType[AccountRoleType["ManagedCareMedicaidPlan"] = 34] = "ManagedCareMedicaidPlan";
    AccountRoleType[AccountRoleType["StatePharmacyAssistanceProgram"] = 35] = "StatePharmacyAssistanceProgram";
    AccountRoleType[AccountRoleType["MedicarePartABPlan"] = 36] = "MedicarePartABPlan";
    AccountRoleType[AccountRoleType["AidsDrugAssistanceProgram"] = 37] = "AidsDrugAssistanceProgram";
    AccountRoleType[AccountRoleType["StatePlan"] = 38] = "StatePlan";
    AccountRoleType[AccountRoleType["Provider"] = 39] = "Provider";
    AccountRoleType[AccountRoleType["ExclusiveProviderOrganization"] = 40] = "ExclusiveProviderOrganization";
    AccountRoleType[AccountRoleType["IndemnityInsurance"] = 41] = "IndemnityInsurance";
    AccountRoleType[AccountRoleType["HealthMaintenanceOrganization"] = 42] = "HealthMaintenanceOrganization";
    AccountRoleType[AccountRoleType["PointOfServicePlan"] = 43] = "PointOfServicePlan";
    AccountRoleType[AccountRoleType["PreferredProviderOrganization"] = 44] = "PreferredProviderOrganization";
    AccountRoleType[AccountRoleType["Self"] = 45] = "Self";
    AccountRoleType[AccountRoleType["OfficeContact"] = 46] = "OfficeContact";
    AccountRoleType[AccountRoleType["Pharmacy"] = 47] = "Pharmacy";
    AccountRoleType[AccountRoleType["MedicareA"] = 48] = "MedicareA";
    AccountRoleType[AccountRoleType["Hospital"] = 49] = "Hospital";
    AccountRoleType[AccountRoleType["HospitalOutpatient"] = 50] = "HospitalOutpatient";
    AccountRoleType[AccountRoleType["InfusionCenter"] = 51] = "InfusionCenter";
    AccountRoleType[AccountRoleType["RetailPharmacy"] = 52] = "RetailPharmacy";
    AccountRoleType[AccountRoleType["Foundation"] = 53] = "Foundation";
    AccountRoleType[AccountRoleType["SecondarySupplemental"] = 54] = "SecondarySupplemental";
    AccountRoleType[AccountRoleType["RegisteredNurse"] = 55] = "RegisteredNurse";
    AccountRoleType[AccountRoleType["LicensedPracticalNurse"] = 56] = "LicensedPracticalNurse";
    AccountRoleType[AccountRoleType["CertifiedNursingAssistant"] = 57] = "CertifiedNursingAssistant";
    AccountRoleType[AccountRoleType["MedicalAssistant"] = 58] = "MedicalAssistant";
    AccountRoleType[AccountRoleType["NationalHomeHealthAgency"] = 59] = "NationalHomeHealthAgency";
    AccountRoleType[AccountRoleType["IndependentHomeHealthAgency"] = 60] = "IndependentHomeHealthAgency";
    AccountRoleType[AccountRoleType["Practice"] = 61] = "Practice";
    AccountRoleType[AccountRoleType["PerDiemContractIndividual"] = 62] = "PerDiemContractIndividual";
    AccountRoleType[AccountRoleType["Employee"] = 63] = "Employee";
})(AccountRoleType || (AccountRoleType = {}));
//# sourceMappingURL=accountRoleType.js.map